'use strict';

module.exports = ['$interval', 'moment',
    function($interval, moment) {

        return {
            restrict: 'A',
            scope: {
                rmActiveBroadcast: '@',
                broadcast: '='
            },
            link: function(scope, element, attributes) {
                let stop = moment(scope.broadcast.stop);

                function checkActive() {
                    let now = moment();
                    if(stop.diff(now) < 0) {//already inactive

                        if(scope.rmActiveBroadcast == 'active') {
                            element.css('opacity', 0.75);
                            scope.rmActiveBroadcast = 'inactive';
                        }
                    } else {
                        if(scope.rmActiveBroadcast == 'inactive') {
                            element.css('opacity', 1);
                            scope.rmActiveBroadcast = 'active';
                        }

                        let start = moment(scope.broadcast.start);
                        if(start.diff(now) < 0) {
                            let nowEl = angular.element('.dashboard-container').find('#now');
                                nowEl.css('display', 'block');

                            if(nowEl.length > 0) {
                                if(!element.prev().is(nowEl)) {//if true the divider is already at the right broadcast
                                    $(element).before(nowEl);
                                }
                            }
                        }
                    }
                }

                let interval = $interval(checkActive, 5000); //set an interval and check the active state

                scope.$on('$destroy', () => {
                    $interval.cancel(interval);
                });

                checkActive();
            }
        };
    }
];

